module.exports = __webpack_public_path__ + "static/img/20250320001.4657e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320001.jpg
// module id = S2QQ
// module chunks = 0